import React, { Children, useEffect, useState } from 'react';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { DOORS } from '../itemIds';
import { useSequenceStore } from '~/training/sequence/SequenceStore';
import { Wrapper } from './components/Wrapper';
import { x } from '@xstyled/styled-components';
import { Floor } from './components/Floor';
import { DoorsProvider, useDoorsStore } from './DoorsStore';
import { useEditorStore } from '~/shell/Store';
import styled from '@xstyled/styled-components';
interface Props {
  id: string;
  header?: { title: string[]; subtitle: string; icon: string };
}

export type DoorsDefinition = ItemDefinition<typeof DOORS, Props>;

export class Doors extends Item<typeof DOORS, Props> {
  protected render({ children, header }: RenderProps<Props>) {
    const { addBlocker } = useSequenceStore();
    const { setDoorIds } = useDoorsStore();
    const { contentEditable } = useEditorStore();
    const childArray = Children.toArray(children);
    const [showTooltip, setShowTooltip] = useState(true);

    useEffect(() => {
      if (!header) {
        const ids = childArray.map((c: any) => c.props.id).filter(Boolean);
        setDoorIds(ids);
        ids.forEach((id: string) => addBlocker(id));
      }
    }, [header]);

    return (
      <DoorsProvider>
        <Wrapper header={header}>
          <x.ul position="relative">
            {childArray.map((c: any, i: number) => {
              const isMiddle = i === Math.floor(childArray.length / 2);
              return (
                <li
                  key={c?.props?.id ?? i}
                  style={{ position: 'relative' }}
                  onClick={() => {
                    if (!contentEditable && isMiddle && showTooltip) {
                      setShowTooltip(false);
                    }
                  }}
                >
                  {c}
                </li>
              );
            })}
          </x.ul>
          <Floor />
        </Wrapper>
      </DoorsProvider>
    );
  }
}

registry[DOORS] = Doors;
